module.exports = __webpack_public_path__ + "static/media/StopHand.154398db.jpg";